<template>
    <el-popover
            placement="right"
            width="600"
            trigger="click">
        <el-form ref="form" :model="form" size="small">
            <el-form-item style="margin-bottom: 5px" prop="remark">
                <el-input
                        v-model="form.remark"
                        placeholder="请输入备注（选填）"/>
            </el-form-item>
            <el-form-item style="margin-bottom: 0" prop="num">
                <el-input
                        v-model="form.num"
                        style="width: 240px"
                        type="number"
                        placeholder="请输入">
                    <template slot="prepend">数值</template>
                </el-input>
                <el-button
                        style="margin-left: 10px"
                        type="primary"
                        @click="submitFunc">添加
                </el-button>
            </el-form-item>
        </el-form>
        <div style="padding: 15px 5px 0">
            <strong style="padding-right: 50px">数值合计：{{totalNum}}</strong>
            <strong>CX合计：{{cx}}</strong>
        </div>
        <el-table
                v-loading="loading"
                :data="list"
                :row-key="row=>JSON.stringify(row)"
                height="300px">
            <el-table-column align="center" label="CX" type="index" :index="indexMethod"/>
            <el-table-column align="center" prop="num"/>
            <el-table-column width="180" align="center" label="时间" prop="createdTime"/>
            <el-table-column label="操作人" align="center" prop="creatorUsername"/>
            <el-table-column width="150" align="center" label="备注" prop="remark"/>
        </el-table>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :page-size="10"
                :pager-count="5"
                :total="total"
                :current-page="currentPage"/>
        <el-button slot="reference" type="primary" size="mini" @click="getList()">备注</el-button>
    </el-popover>
</template>
<script>
    import {mapActions} from 'vuex'

    export default {
        props: {
            userId: [String, Number]
        },
        data() {
            return {
                loading: false,
                form: {
                    num: '',
                    remark: '',
                },
                cx: 0,
                totalNum: 0,
                list: [],
                total: 0,
                currentPage: 1
            }
        },
        methods: {
            ...mapActions('userOnline', ['getUserOnlineRemarkList', 'createRemark']),
            indexMethod(index) {
                return `C${this.total - (index + (this.currentPage - 1) * 10)}`
            },
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getUserOnlineRemarkList({
                    page,
                    size: 10,
                    userId: this.userId
                }).then(res => {
                    this.loading = false;
                    this.list = res.data.beanList;
                    this.cx = res.data.cx;
                    this.totalNum = res.data.totalNum;
                    this.total = res.data.total;
                });
            },
            submitFunc() {
                if (this.form.num === '') {
                    this.$message.error('请输入数值');
                    return
                }
                this.createRemark({
                    num: this.form.num,
                    remark: this.form.remark,
                    userId: this.userId
                }).then(() => {
                    this.$message.success('添加成功');
                    this.$refs.form.resetFields();
                    this.getList(this.currentPage)
                })
            }
        }
    }
</script>